import {
    useEffect,
    useEffectEvent,
    useRef,
} from 'react'
import {AnalyticsEventReporter} from '../../../../../helpers/AnalyticsEventReporter'

interface AdsListIntersectionObserverProps {
    onLoadMore: (infiniteScroll?: boolean) => void
    disabled?: boolean
    presentation?: 'list' | 'grid'
}

export function AdsListIntersectionObserver(props: AdsListIntersectionObserverProps) {

    const {
        onLoadMore,
        disabled,
        presentation = 'grid',
    } = props

    const observedElementRef = useRef<HTMLDivElement | null>(null)

    // Событие пересечения.
    const handleIntersection = useEffectEvent((
        entries: IntersectionObserverEntry[]
    ) => {
        if (entries[0]?.isIntersecting) {
            onLoadMore(true)
        }
    })

    // Активация/деактивация наблюдателя.
    useEffect(() => {
        if (disabled || !observedElementRef.current) {
            return
        }

        const offset: number = presentation === 'list' ? 800 : 400

        try {
            const observer: IntersectionObserver = new IntersectionObserver(
                handleIntersection,
                {
                    root: null, // viewport
                    rootMargin: `0px 0px ${Math.abs(offset)}px 0px`,
                    threshold: 0,
                }
            )

            observer.observe(observedElementRef.current)

            return () => {
                observer.disconnect()
            }
        } catch (error) {
            AnalyticsEventReporter.exception(error, 'AdsListIntersectionObserver')
            return () => {
            }
        }
    }, [disabled, presentation])

    return (
        <div
            className="ads-list-intersection-observer"
            ref={observedElementRef}
        />
    )
}
